// extracted by mini-css-extract-plugin
export default {"inputTextWithIcon":"InputNumber_inputTextWithIcon__tvTb7","textField":"InputNumber_textField__iMjIB"};